import React, { FC, useContext } from 'react';
import { TextButton } from '@wix/design-system';
import { marketplaceHeaderClientGenericClick } from '@wix/bi-logger-marketplace/v2';
import { MARKETPLACE_HEADER_ENTRY } from '@utils/constants';
import { HeaderContext } from '@components/Contexts/HeaderContext';
import { dataHooks } from '../../utils/constants';
import { useBi } from '../../../Hooks/useBi';

interface StudioTemplatesLinkProps {
  label: string;
  marketplaceUrlPrefix: string;
  pageName: string;
  isMobileView?: boolean;
}

const StudioTemplatesLink: FC<StudioTemplatesLinkProps> = ({
  label,
  marketplaceUrlPrefix,
  pageName,
  isMobileView,
}) => {
  const logger = useBi();
  const context = useContext(HeaderContext);

  const finalEntry = context?.entry || MARKETPLACE_HEADER_ENTRY;
  const finalOrigin = context?.origin || pageName;

  return (
    <TextButton
      as="a"
      dataHook={dataHooks.studioTemplatesLink}
      skin="dark"
      size="medium"
      weight={isMobileView ? 'normal' : 'thin'}
      onClick={() => {
        logger.report(
          marketplaceHeaderClientGenericClick({
            clickType: 'studio templates',
            pageName,
          }),
        );
      }}
      href={`${marketplaceUrlPrefix}/templates?entry=${finalEntry}&origin=${finalOrigin}`}
    >
      {label}
    </TextButton>
  );
};

export default StudioTemplatesLink;
